import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import axios from 'axios';
import Cookies from 'universal-cookie';

import MainPage from '../pages/MainPage'
import AboutUsPage from '../pages/AboutUsPage';
import ProductsPage from '../pages/ProductsPage';
import OneInfLenderPage from '../pages/OneInfLenderPage'
import LoanTapLenderPage from '../pages/LoanTapLenderPage';
import IIFLLenderPage from '../pages/IIFLLenderPage';
import PoonawallaLenderPage from '../pages/PoonawallaLenderPage';
import IciciLenderPage from '../pages/IciciLenderPage';
import IndifiLenderPage from '../pages/IndifiLenderPage';
//import CreditEnableLenderPage from '../pages/CreditEnableLenderPage';
import ApplicationsPage from '../pages/ApplicationsPage';
import TataCapitalPage from '../pages/TataCapitalPage';

class RouterComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            flag: false,
            visited: sessionStorage.getItem('visited') ? true : false
        };
    }

    userCurrentStatus(glid) {
        return new Promise((resolve) => {
            var flag = false;

            var host = window.location.hostname;

            var statusUrl = host == 'loans.indiamart.com' ? 'https://loans.indiamart.com/functions.php' : 'https://dev-loans.indiamart.com/functions.php';

            var statusData = {
                "functionName": "checkCurrentStatus",
                "glid": glid,
            };

            var formData = new FormData();
            for (var key in statusData) {
                formData.append(key, statusData[key]);
            }

            axios({
                method: 'post',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                url: statusUrl,
                data: statusData,
                timeout: 10000
            }).then((response) => {
                //console.log("response => ", response['data']);
                if (response['data'] == true) {
                    flag = true;
                }
                resolve(flag);
            }).catch(error => {
                console.error("Error occurred: ", error);
                resolve(false);
            });

        });

    }


    async componentDidMount() {
        // Set sessionStorage
        if (!sessionStorage.getItem('visited')) {
            sessionStorage.setItem('visited', 'true');
        }

        const cookie = new Cookies();
        var glid = '';

        let visitorData = cookie.get('ImeshVisitor');
        if (visitorData) {
            visitorData = visitorData.split("|");

            let sd = [];
            visitorData.map((data) => {
                sd = data.split("=")
                if (sd[0] == "glid") {
                    glid = sd[1]
                }
            })
        }

        if (glid) {
            try {
                const userFlag = await this.userCurrentStatus(glid);
                this.setState({ flag: userFlag });
            } catch (error) {
                console.error("Error fetching user status: ", error);
            }
        }
    }

    render() {
        return (
            <>
                <Router>
                    <div>
                        <Routes>
                            <Route path="/" element={!this.state.visited && this.state.flag ? <Navigate to="/applications" /> : <MainPage />} />
                            <Route path="/applications" element={<ApplicationsPage />} />
                            <Route path="/about" element={<AboutUsPage />} />
                            <Route path="/product" element={<ProductsPage />} />
                            {/* <Route path="/partner/oneinfinity" element={<OneInfLenderPage />} /> */}
                            <Route path="/partner/loantap" element={<LoanTapLenderPage />} />
                            <Route path="/partner/iifl" element={<IIFLLenderPage />} />
                            <Route path="/partner/icici" element={<IciciLenderPage />} />
                            {/* <Route path="/partner/poonawalla" element={<PoonawallaLenderPage />} /> */}
                            <Route path="/partner/indifi" element={<IndifiLenderPage />} />
                            {/* <Route path="/partner/creditenable" element={<CreditEnableLenderPage/>}/> */}
                            <Route path="/partner/tatacapital" element={<TataCapitalPage />} />
                        </Routes>
                    </div>
                </Router>
            </>
        );
    }

}

export default RouterComponent;
